(() => {
    const reduceMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
        const stopSmil = () => document.querySelectorAll('.xan').forEach((svg) => {
            if (typeof svg.pauseAnimations === 'function') svg.pauseAnimations();
        });
        if (document.readyState !== 'loading') stopSmil();
        else document.addEventListener('DOMContentLoaded', stopSmil);
    }

    const headH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--head-h'), 10) || 97;
    const HEADER_OFFSET = headH + 28;

    const scrollFns = [];
    let raf = 0;
    let listening = false;

    const runScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
            raf = 0;
            const y = window.scrollY || window.pageYOffset || 0;
            const vh = window.innerHeight || 0;
            for (const fn of scrollFns) fn(y, vh);
        });
    };

    const listen = () => {
        if (listening) return;
        listening = true;
        window.addEventListener('scroll', runScroll, { passive: true });
        window.addEventListener('resize', runScroll);
    };

    const register = (fn) => {
        scrollFns.push(fn);
        listen();
        runScroll();
    };

    const onScrollWhileVisible = (el, fn, margin) => {
        if (!el || !('IntersectionObserver' in window)) {
            register(fn);
            return;
        }
        let visible = true;
        new IntersectionObserver((entries) => {
            visible = entries[entries.length - 1].isIntersecting;
            if (visible) runScroll();
        }, { rootMargin: margin || '200px 0px' }).observe(el);
        register((y, vh) => { if (visible) fn(y, vh); });
    };

    const scrollToEl = (el, extra) => {
        const top = el.getBoundingClientRect().top +
            (window.scrollY || window.pageYOffset || 0) - HEADER_OFFSET - (extra || 0);
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const capcod = window.capcod = {
        reduceMotion,
        headerOffset: HEADER_OFFSET,
        scrollToEl,
        refresh: runScroll,
        onScroll: register,
        onScrollWhileVisible,
    };

    const head = document.querySelector('[data-head]');
    const burger = head && head.querySelector('[data-burger]');

    const closeMenu = () => {
        if (!head) return;
        head.classList.remove('is-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
    };
    capcod.closeMenu = closeMenu;

    if (burger) {
        burger.addEventListener('click', () => {
            const open = head.classList.toggle('is-open');
            burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }

    if (head) {
        const norm = (p) => (p || '').replace(/\/+$/, '') || '/';
        const here = norm(location.pathname);
        const isRoot = (p) => p === '/' || p === '/en';
        const onPath = (p) => here === p || (!isRoot(p) && here.startsWith(p + '/'));

        const logo = head.querySelector('.head-logo');
        let siteHost = location.host;
        try { if (logo) siteHost = new URL(logo.href, location.origin).host; } catch (e) {}

        head.querySelectorAll('.head-nav > a, .head-mobile > a:not(.btn), .head-drop-btn, .head-mega-item').forEach((a) => {
            let path;
            try {
                const u = new URL(a.href, location.origin);
                if (u.host !== location.host && u.host !== siteHost) return;
                path = norm(u.pathname);
            } catch (e) { return; }
            if (onPath(path)) {
                a.classList.add('is-active');
                a.setAttribute('aria-current', 'page');
            }
        });

        head.querySelectorAll('[data-drop]').forEach((drop) => {
            if (drop.querySelector('.head-mega-item.is-active')) {
                drop.querySelector('[data-drop-btn]').classList.add('is-active');
            }
        });

        head.querySelectorAll('.head-mobile-pole').forEach((pole) => {
            if (!pole.querySelector('.head-mega-item.is-active')) {
                return;
            }
            pole.classList.add('is-active');
            pole.open = true;
        });

        const DROP_CLOSE_DELAY = 120;
        const DROP = { OPEN: 'open', CLOSED: 'closed' };
        const drops = Array.from(head.querySelectorAll('[data-drop]'));
        let dropTimer = 0;

        const setDrop = (drop, state) => {
            const open = state === DROP.OPEN;
            drop.classList.toggle('is-open', open);
            drop.querySelector('[data-drop-btn]').setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        const openDrop = (drop) => {
            clearTimeout(dropTimer);
            drops.forEach((d) => setDrop(d, d === drop ? DROP.OPEN : DROP.CLOSED));
        };

        drops.forEach((drop) => {
            const btn = drop.querySelector('[data-drop-btn]');
            let touchOpens = false;

            drop.addEventListener('pointerenter', () => openDrop(drop));
            drop.addEventListener('pointerleave', () => {
                clearTimeout(dropTimer);
                dropTimer = setTimeout(() => setDrop(drop, DROP.CLOSED), DROP_CLOSE_DELAY);
            });
            drop.addEventListener('focusin', () => openDrop(drop));
            drop.addEventListener('focusout', (e) => {
                if (!drop.contains(e.relatedTarget)) {
                    setDrop(drop, DROP.CLOSED);
                }
            });

            // Touch without hover: first tap opens the panel, second tap follows the link.
            btn.addEventListener('pointerdown', (e) => {
                touchOpens = e.pointerType === 'touch' && !drop.classList.contains('is-open');
            });
            btn.addEventListener('click', (e) => {
                if (!touchOpens) {
                    return;
                }
                e.preventDefault();
                openDrop(drop);
            });
        });

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') {
                return;
            }
            const open = drops.find((d) => d.classList.contains('is-open'));
            if (!open) {
                return;
            }
            setDrop(open, DROP.CLOSED);
            open.querySelector('[data-drop-btn]').focus();
        });
    }

    if (head && head.classList.contains('site-head--overlay')) {
        capcod.onScroll((y) => head.classList.toggle('is-scrolled', y > 24));
    }

    if (!reduceMotion) {
        document.querySelectorAll('[data-parallax-bg]').forEach((bg) => {
            const sec = bg.parentElement;
            if (!sec) return;
            onScrollWhileVisible(sec, (y, vh) => {
                const r = sec.getBoundingClientRect();
                const offset = r.top + r.height / 2 - vh / 2;
                bg.style.transform = `translate3d(0, ${offset * -0.12}px, 0)`;
            });
        });
    }

    if (!reduceMotion && 'IntersectionObserver' in window) {
        document.querySelectorAll('[data-reveal-group]').forEach((group) => {
            const step = parseInt(group.dataset.revealGroup, 10) || 90;
            const span = parseInt(group.dataset.revealSpan, 10) || 6;
            group.querySelectorAll('[data-reveal]').forEach((el, i) => {
                el.style.setProperty('--reveal-delay', ((i % span) * step) + 'ms');
            });
        });

        const revealables = document.querySelectorAll('[data-reveal]');
        if (revealables.length) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('is-in');
                    io.unobserve(entry.target);
                });
            }, { rootMargin: '0px 0px -12% 0px' });
            revealables.forEach((el) => io.observe(el));
        }
    }

    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;
        const href = a.getAttribute('href') || '';
        const id = href.slice(href.indexOf('#') + 1);
        if (!id) return;
        const target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        closeMenu();
        scrollToEl(target);
    });

    const PILL_ICONS = {
        lieu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>',
        contrat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/></svg>',
        niveau: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>',
        temps: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
        tt: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"/><path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>',
    };
    document.querySelectorAll('.job-meta__item').forEach((el) => {
        if (el.classList.contains('job-meta__item--date')) return;
        el.textContent = el.textContent.replace(/^\s*#\s*/, '').replace(/^(lieu|contrat|niveau|temps|tt)-/i, '');
        const m = (el.getAttribute('data-tag') || '').match(/^hash-(lieu|contrat|niveau|temps|tt)-/);
        if (m) el.insertAdjacentHTML('afterbegin', PILL_ICONS[m[1]]);
    });

    document.querySelectorAll('.exp-badge').forEach((badge) => {
        badge.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && /\S/.test(node.textContent)) {
                node.textContent = node.textContent.replace(/^\s*#\s*/, '');
            }
        });
    });

    // Titre expertise « X & Y » → 1re ligne (encre) jusqu'au « & »,
    // 2e ligne en dégradé de l'accent du pôle. Le titre reste la page Ghost.
    document.querySelectorAll('[data-split-amp]').forEach((h) => {
        const raw = h.textContent.trim();
        const cut = raw.indexOf('&');
        if (cut < 0) return;
        const head = raw.slice(0, cut + 1).trim();
        const tail = raw.slice(cut + 1).trim();
        if (!tail) return;
        const line1 = document.createElement('span');
        line1.className = 'ex-ln';
        line1.textContent = head;
        const grad = document.createElement('span');
        grad.className = 'ex-grad';
        grad.textContent = tail;
        const line2 = document.createElement('span');
        line2.className = 'ex-ln';
        line2.appendChild(grad);
        h.textContent = '';
        h.append(line1, line2);
    });

    // Savoir-faire « studio » : visuel de l'offre survolée qui suit le curseur.
    if (!reduceMotion && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        document.querySelectorAll('[data-ex-st]').forEach((wrap) => {
            const float = wrap.querySelector('.ex-st-float');
            const shots = wrap.querySelectorAll('.ex-st-shot');
            const rows = wrap.querySelectorAll('.ex-st-row');
            if (!float || !shots.length) return;

            let raf = 0, tx = 0, ty = 0, cx = 0, cy = 0, seeded = false;
            const step = () => {
                cx += (tx - cx) * 0.13;
                cy += (ty - cy) * 0.13;
                float.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-58%)';
                raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.4 ? requestAnimationFrame(step) : 0;
            };
            wrap.addEventListener('pointermove', (e) => {
                const r = wrap.getBoundingClientRect();
                tx = e.clientX - r.left;
                ty = e.clientY - r.top;
                if (!seeded) { cx = tx; cy = ty; seeded = true; }
                if (!raf) raf = requestAnimationFrame(step);
            });

            const showShot = (id) => shots.forEach((s) => s.classList.toggle('is-on', s.dataset.stShot === id));
            const edgeFrom = (row, e) => {
                const r = row.getBoundingClientRect();
                row.style.setProperty('--st-origin', e.clientY < r.top + r.height / 2 ? '0%' : '100%');
            };
            rows.forEach((row) => {
                row.addEventListener('pointerenter', (e) => { edgeFrom(row, e); showShot(row.dataset.stRow); });
                row.addEventListener('pointerleave', (e) => edgeFrom(row, e));
            });
            wrap.addEventListener('pointerleave', () => showShot(null));
        });
    }
})();
